function EcommerceService ( $q, $timeout, $window ) {
  "ngInject";

  /**
   * Метод для формирования запроса о транзакции в Яндекс.Метрику
   *
   * @param transactionObject
   * @param delay - задержка перед резолвом Promise (мс)
   */
  var makeEcommerceTransaction = function( transactionObject, delay ) {
    var defer = $q.defer();

    // Яндекс DataLayer (если подключен)
    if( typeof($window.dataLayer) !== "undefined" ) {
      var yandexProductsList = [];

      transactionObject.orderItems.forEach( function ( item ) {
        yandexProductsList.push({
          "id": item.id,
          "name": item.name,
          "category": item.category,
          "price": item.price,
          "quantity": item.quantity
        });
      });

      $window.dataLayer.push({
        "ecommerce": {
          "purchase": {
            "actionField": {
              "id": transactionObject.orderNumber
            },
            "products": yandexProductsList
          }
        }
      });
    }

    // Всегда резолвим Promise с указанной задержкой
    delay = parseInt(delay) || 0;
    $timeout( function () {
      defer.resolve();
    }, delay );

    return defer.promise;
  }

  return {
    makeEcommerceTransaction: makeEcommerceTransaction
  }

}

module.exports = EcommerceService;
